import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { FromFieldControl } from "../form-field-control";
import { Observable } from "rxjs";
import {
	FormFieldEvent,
	FormFieldEventType,
	FormFieldControlType
} from "../form-field-enums";
import { FormGroupDirective } from "@angular/forms";

@Component({
    selector: "tc-auto-complete-form-field",
    templateUrl: "./auto-complete-form-field.component.html",
    styleUrls: ["./auto-complete-form-field.component.scss"],
    standalone: false
})
export class AutoCompleteFormFieldComponent extends FromFieldControl implements OnInit {
	@Input() options: any[];
	@Input() options$: Observable<any[]>;
	@Input() displayProperty: string;
	@Input() displayFn: (option?: any) => string | undefined;
	@Input() optionDisplayFn: (option?: any) => string | undefined;
	@Input() optionClassFn: (option?: any) => string | undefined;
	@Input() charThreshold = 2;
	@Input() classList: string;
	@Input() maxLength;
	@Input() dealWithNullKeyOption = false;
	@Input() voidValidImage = false;
	@Input() voidValidInvalidImage = false;
	@Input() takeFullWidth = false;
	@Input() borderBottom = false;
	@Input() customPanelWidth = "auto";
	@Input() focused = false;

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	ngOnInit() { }

	_optionSelected(eventData: any) {
		const eventVal = <FormFieldEvent>{
			type: FormFieldEventType.OPTION_SELECTED,
			control: this.__controlInfo(FormFieldControlType.AUTOCOMPLETE)
		};

		if (eventData) {
			eventVal.data = eventData;
		} else {
			this.__control.reset();
		}

		console.log("option selected : eventVal", eventVal);

		this.event.emit(eventVal);
	}

	_inputChanged(eventData: any) {
		this.event.emit(<FormFieldEvent>{
			type: FormFieldEventType.INPUT_CHANGED,
			data: eventData,
			control: this.__controlInfo(FormFieldControlType.AUTOCOMPLETE)
		});
	}

	get __hasError() {
		return this.__control.touched && !this.valid && this.__control.invalid;
	}

	get imageUrl() {
		return this.valid && this.validImage ? this.validImage : (this.invalidImage || "/assets/img/icons/exclamation-large.svg");
	}

	get showImage() {
		if (this.voidValidInvalidImage) {
			return false;
		}
		return (this.valid && this.validImage) || this.__hasError;
	}
}
